import styled from 'styled-components';
import { CommonButton } from '../../common/CommonButton';
import { RootPortal } from '../../common/RootPortal';
import { MODAL_TYPE } from '../../../store/modalStore';
import { useTextVariant } from '../../../hook/useTextVariant';
import { COMMON_MODAL_CONSTANTS } from '../../../constants/commonModal';
import { CommonModalViewProps } from '../CommonModal';

export const CommonModalMobile = ({
  isVisibleCommon,
  modalType,
  notStartText,
  onConfirm,
  onNotAgree,
  onReSelect,
}: CommonModalViewProps) => {
  const { getText } = useTextVariant(COMMON_MODAL_CONSTANTS, true);

  return (
    <RootPortal>
      <ModalWrap $visible={isVisibleCommon}>
        <Dim />
        <ModalContent $visible={isVisibleCommon}>
          <Content style={{ height: modalType === MODAL_TYPE.REAL_NOT_AGREE ? 125 : 104 }}>
            {modalType === MODAL_TYPE.NOT_START && <ContentText>{notStartText}</ContentText>}
            {modalType === MODAL_TYPE.CHECK_TICKET && (
              <ContentText>{getText('checkTicket')}</ContentText>
            )}
            {modalType === MODAL_TYPE.IS_AGREE_PRIVACY && (
              <ContentText>{getText('isAgreePrivacy')}</ContentText>
            )}
            {modalType === MODAL_TYPE.REAL_NOT_AGREE && (
              <ContentText>{getText('realNotAgreeText')}</ContentText>
            )}
            {modalType === MODAL_TYPE.CHECK_AGREE && (
              <ContentText>{getText('checkAgree')}</ContentText>
            )}
            {modalType === MODAL_TYPE.COMPLETE_AGREE && (
              <ContentText>{getText('completeAgree')}</ContentText>
            )}
            {modalType === MODAL_TYPE.REAL_NOT_AGREE && (
              <RealAgreeText>{getText('realAgreeText')}</RealAgreeText>
            )}
            {(modalType === MODAL_TYPE.CHECK_AGREE || modalType === MODAL_TYPE.COMPLETE_AGREE) && (
              <CheckTournamentText>{getText('checkTournamentText')}</CheckTournamentText>
            )}
          </Content>

          {modalType === MODAL_TYPE.REAL_NOT_AGREE && (
            <ButtonRowContainer>
              <CommonButton
                click={onNotAgree}
                text={getText('notAgreeBtn') as string}
                theme={'dark'}
              />
              <CommonButton click={onReSelect} text={getText('reSelectBtn') as string} />
            </ButtonRowContainer>
          )}
          {modalType !== MODAL_TYPE.REAL_NOT_AGREE && (
            <ButtonContainer onClick={onConfirm}>
              <CommonButton text={getText('confirmBtn') as string} />
            </ButtonContainer>
          )}
        </ModalContent>
      </ModalWrap>
    </RootPortal>
  );
};

const ButtonRowContainer = styled.div`
  width: 100%;
  position: absolute;
  left: 0;
  display: flex;

  > div:first-child {
    button {
      border-radius: 0;
      border-bottom-left-radius: 20px;
    }
  }

  > div:last-child {
    button {
      border-radius: 0;
      border-bottom-right-radius: 20px;
    }
  }
`;

const ButtonContainer = styled.div`
  width: 100%;
  position: absolute;
  left: 0;

  button {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
  }
`;

const ModalWrap = styled.div<{ $visible: boolean }>`
  visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10000000;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Dim = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
`;

const ModalContent = styled.div<{ $visible: boolean }>`
  width: 90%;
  max-height: 80%;
  background: #302e2d;
  box-shadow: 0px 1px 1px 0px rgba(255, 255, 255, 0.2) inset;
  position: relative;
  z-index: 2;
  transform: ${({ $visible }) => ($visible ? 'scale(1)' : 'scale(0.75)')};
  transition: transform 0.15s ease-in-out;
  border-radius: 20px 20px 0px 0px;
`;

const Content = styled.div`
  border-radius: 8px;
  list-style: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const ContentText = styled.p`
  color: #eee;
  text-align: center;
  font-size: 17px;
  line-height: 23px;
  letter-spacing: -0.3px;
`;

const RealAgreeText = styled.p`
  color: #f86855;
  text-align: center;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.56px;
  margin-top: 4px;
`;

const CheckTournamentText = styled.p`
  margin-top: 4px;
  color: #b2b2b2;
  text-align: center;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.7px;
`;
